package fr.frux.feature.harvestcreate

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel
import fr.frux.shared.domain.model.HarvestTarget

/**
 * Contrat de fabrique du [CreateHarvestViewModel], honoré par le composition root (#43).
 *
 * `target` vient de la route, pas du graphe : c'est le seul paramètre que l'appelant fournit.
 */
fun interface CreateHarvestViewModelFactory {
    fun create(target: HarvestTarget): CreateHarvestViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalCreateHarvestViewModelFactory =
    staticCompositionLocalOf<CreateHarvestViewModelFactory> {
        error(
            "CreateHarvestViewModelFactory absente : le composition root doit l'installer " +
                "(cf. FruxCompositionRoot, #43)",
        )
    }

/** Fabrique le CreateHarvestViewModel depuis la fabrique fournie par le root. */
@Composable
fun rememberCreateHarvestViewModel(target: HarvestTarget): CreateHarvestViewModel {
    val factory = LocalCreateHarvestViewModelFactory.current
    return viewModel { factory.create(target) }
}
